<script>
	import { onMount, setContext } from 'svelte'
	import { getColors } from '../../colors'
	import MediaQuery, { breakpoint, isTouch, platform } from '../../components/MediaQuerySsr.svelte'
	import { getLanguage, translate } from '../../language'
	import { hexToRgb } from '../../utils'
	// import { onMount } from '../../../../ukraine_war/node_modules/svelte/types/runtime'

	import { configCases } from './constants'

	// import Minimap from '../../components/Minimap.svelte'

	import StaticAnnotatedMap from '../../components/StaticAnnotatedMap.svelte'
	/** deprecated on launch day due to non-validatable data */
	// import DamageStatistics from '../../components/StaticAnnotatedMap/DamageStatistics.svelte'
	import Legend from '../../components/StaticAnnotatedMap/Legend.svelte'
	import { writable } from 'svelte/store'

	// ///////////////////////////////////////////////////////////
	// init GMS graphic
	// ///////////////////////////////////////////////////////////

	export let options
	export let caseId

	const t = translate
	const colors = getColors()
	// const language = getLanguage()

	options = { case_id: caseId, ...options }

	// ///////////////////////////////////////////////////////////
	// init, constants and definitions
	// ///////////////////////////////////////////////////////////
	let dataLoaded = false

	const isMobile = writable(undefined)
	setContext('isMobile', isMobile)
	$: $isMobile = $breakpoint === 'mobile-m' || $breakpoint === 'mobile-s'
	$: responsiveMode = $isMobile ? 'mobile' : 'desktop'

	const basePath = `${PATH}assets/02_static_annotated_map/${caseId}`

	$: vectorPathRemote = `${basePath}/${caseId}-${responsiveMode}-remote-highlights.svg`
	$: imagePathRemote = `${basePath}/${caseId}-${responsiveMode}-remote-base-2x.min.png`
	$: vectorPathClose = `${basePath}/${caseId}-${responsiveMode}-close-highlights.svg`
	$: imagePathClose = `${basePath}/${caseId}-${responsiveMode}-close-base-2x.min.png`

	const config = configCases[caseId]

	// ///////////////////////////////////////////////////////////
	// load data
	// ///////////////////////////////////////////////////////////

	onMount(async () => {
		dataLoaded = true
	})

	// ///////////////////////////////////////////////////////////
	// bound to components
	// ///////////////////////////////////////////////////////////
	let graphicWidth
	let graphicHeight
</script>

<MediaQuery />
<div
	class="tsg-02_annotation_map_static"
	class:is-touch={$isTouch}
	style:--background-color={colors.background}
	style:--background-color-raw={Object.values(hexToRgb(colors.background))}
	style:--primary-color={colors.primary}
	style:--text-color={colors.textBlack}
	style:--gray={colors.gray}
	style:--gray-light={colors.grayLight}
	bind:clientWidth={graphicWidth}
	bind:clientHeight={graphicHeight}
>
	<!-- {#if config.statistics}
		<DamageStatistics statistics={config.statistics} {t} {colors} />
	{/if} -->
	<Legend {t} {colors} />

	{#if !dataLoaded}
		<p>Loading...</p>
	{/if}
	<div class="map-container-outer remote">
		<StaticAnnotatedMap
			maptype="vector"
			imagePath={imagePathRemote}
			vectorPath={vectorPathRemote}
			case_id={caseId}
			case_data={config}
			view={'remote'}
			width={graphicWidth}
		/>
	</div>
	{#if !config.noCloseUp}
		<h3 class="closeup-annotation">{t('Detail of City Center')}</h3>
		<div class="map-container-outer close-up">
			<StaticAnnotatedMap
				maptype="vector"
				imagePath={imagePathClose}
				vectorPath={vectorPathClose}
				case_id={caseId}
				case_data={config}
				view={'close'}
				width={graphicWidth}
			/>
		</div>
	{/if}
</div>

<style lang="scss">
	.tsg-02_annotation_map_static {
		user-select: none;
		position: relative;
		width: 100%;
		//max-width: 620px;
		margin: 0 auto;
		display: flex;
		gap: 1rem;
		flex-direction: column;
		// @media (max-width: $breakpoint-mobile-m) {
		// 	display: flex;
		// 	flex-direction: column-reverse;
		// }
		--dark-grey: #635454;

		& .closeup-annotation {
			font-size: 14px;
			font-weight: 300;
			font-style: italic;
			letter-spacing: 2px;
			margin-top: 0;
			margin-bottom: -18px;
			text-align: left;
			text-transform: uppercase;
			color: var(--dark-grey);
		}
	}

	// .vector-overlay {
	// 	position: absolute;
	// 	top: 0;
	// 	left: 0;
	// }

	:global(.translation-string) {
		fill: white;
		font-size: 14px;
	}

	.statistics {
		$gap: 25px;

		display: flex;
		justify-content: space-between;
		gap: $gap;
		margin-top: 10px;

		@media (max-width: $breakpoint-mobile-m) {
			flex-direction: column;
			align-items: center;
			gap: 10px;
		}

		&__section {
			width: 20%;

			&:last-child {
				width: 60%;

				@media (max-width: $breakpoint-mobile-m) {
					width: 100%;
				}
			}

			@media (max-width: $breakpoint-mobile-m) {
				width: 100%;
			}
		}

		&__subsection {
			display: flex;
			justify-content: space-between;
			gap: $gap;
			position: relative;
			padding: 0 25px 0 10px;

			@media (max-width: $breakpoint-mobile-m) {
				justify-content: space-around;
			}
		}

		&__item {
			text-align: center;
			display: flex;
			flex-direction: column-reverse;
			justify-content: center;
			align-items: center;
			min-height: 90px;

			@media (max-width: $breakpoint-mobile-m) {
				flex-direction: column;
				min-height: auto;
			}

			&__label {
				opacity: 0.9;
				font-size: 14px;
			}

			&__value {
				font-weight: 700;
				font-size: 20px;
				display: flex;
				align-items: center;
				gap: 5px;
			}

			&__color-swatch {
				content: '';
				width: 15px;
				height: 15px;
				border-radius: 50px;
				background-color: var(--background-color);
				border: 1px solid var(--background-color);
			}
		}
	}

	.map-container-outer {
		&.remote {
			overflow: hidden;
		}

		&.close-up {
			margin-top: 5px;
			// box-shadow: 0px 0px 15px 2.5px var(--gray-light);
			// padding-bottom: 5px;
		}
	}

	:global(#tsg-graphic) {
		overflow: visible !important;
		margin: 0 auto 7px !important;
	}

	:global(.statistics__bracket) {
		height: 100%;
		top: 0;
		position: absolute;

		@media (max-width: $breakpoint-mobile-m) {
			display: none;
		}
	}

	:global(.statistics__bracket.left) {
		min-width: 37px;
		left: -20px;
	}

	:global(.statistics__bracket.right) {
		min-width: 24px;
		right: 0;
	}

	:global(.statistics__bracket > path) {
		stroke: var(--gray) !important;
	}

	:global(.statistics__bracket-mobile) {
		width: 100%;

		@media (min-width: $breakpoint-mobile-m) {
			display: none;
		}
	}
</style>
